<template>
    <!-- <q-chip square outline color="primary" size="md">{{ props.one.kind }}</q-chip> -->
    <!-- <div class="barVertical" /> -->
    <q-btn outlined unelevated no-caps :disable="isDisableBtn" @click="onBtn" class="penal__content">
        <!-- <div class="boxRounded"> -->
        <div class="full-screen flex align-left + justify-between">
            <div class="flex">
                <!-- <div v-if="props.informData?.topFixYn" class="circleTiny" style="display: inline; background-color: #ef2b2a"></div> -->

                <!-- <img v-if="props.informData?.topFixYn" class="dot" src="/assets/images/symbols/dot_red.png" /> -->
                <span v-if="type === 100" class="informTt30 cccBlue">{{ typeStr }}</span>
                <span v-if="type === 200" class="informTt30 cccGrey">{{ typeStr }}</span>
                <span v-if="type === 300" class="informTt30 cccGrey">{{ typeStr }}</span>
                <span v-if="type === 400" class="informTt30 cccRed">{{ typeStr }}</span>

                <span v-if="props.informData?.type" class="txtNormal text-bold q-px-md text-primary b3">{{ props.informData?.type }}</span>
                <span v-if="props.informData?.title" class="informTt30">{{ props.informData?.title }}</span>
                <img v-if="props.informData?.isNew" class="new" src="/assets/images/symbols/dot_red_new.png" />
                <!-- <span v-if="props.informData?.isNew" class="txtNormal text-bold q-px-md text-primary b3">NEW</span> -->
                <!-- <span v-if="props.informData?.contents">{{ props.informData?.contents }}</span> -->
            </div>
            <span class="dateTt30">{{ props.informData?.createdTs }}</span>
        </div>
        <!-- </div> -->
    </q-btn>
</template>

<!-- // 추천학습제목: [추천학습] 새로 배정된 추천학습이 있어요!본문: 3레벨 1레슨 문학이 추천학습으로 배정되었습니다. 
// 진도리셋제목: [진도리셋] 진도리셋이 있어요!본문: 3레벨 1레슨 문학지문이 리셋되었습니다. 
// 진도수정제목: [진도수정] 진도수정이 있어요!본문: 3레벨 1레슨으로 진도수정되었습니다. 
// 수능리셋제목: [진도리셋] 리셋된 수능모의평가가 있어요!본문: 3레벨 2회차 수능모의평가가 리셋되었습니다. -->

<!-- {
    "seq": 13,
    "title": "알림제목12",
    "contents": "알림내용12",
    "creatorName": "관리자",
    "createdTs": "2023.02.23"
  }, -->
<script setup>
import { onMounted, computed, ref, watch, defineProps, defineEmits } from 'vue';
import Comm from '@/components/common.js';

const props = defineProps({
    type: {
        Type: Number,
    },
    informData: {
        Type: Object,
    },
    isDisableBtn: {
        Type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['onOpen']);

const onBtn = () => {
    // if (globalStore?.sound && props.options?.sound) {
    //     soundEffect(props.options?.sound)
    // }
    // console.log('--child-onOpen-');
    emit('onOpen', props.informData);
};

const type = computed(() => {
    const text = props?.informData?.typeStr;
    return Comm.getNoOfInformStudyType(text);
});
const typeStr = computed(() => {
    const text = props?.informData?.typeStr;
    return Comm.getStrOfInformStudyType(text);
});

// const type = computed(() => {
//     const text = props.informData.typeStr;
// console.log('--text-computed - ', text);
//     if (text.includes('추천학습')) return 100;
//     if (text.includes('진도리셋')) return text.includes('수능모의평가') ? 200 : 300;
//     if (text.includes('진도수정')) return 400;
//     return null;
// });

onMounted(() => {});
</script>

<style scoped lang="scss">
.purple {
    color: purple;
}
.red {
    color: red;
}
.q-btn {
    border-radius: 10px;
}

.penal__content {
    display: block;
    width: 100%;
    padding: 3.17vmin 5.67vmin 3.08vmin;
    border: 1px solid #e0e0e0;
    background-color: white;
    text-align: left;

    &:first-of-type {
        margin-top: 5.67vmin;
    }

    &:nth-of-type(n + 2) {
        margin-top: 1.33vmin;
    }

    .full-screen {
        width: 100%;
        .flex {
            align-items: center;
            span {
                &:first-of-type {
                    padding: 0;
                }
                &:nth-of-type(n + 2) {
                    margin-left: 2.67vmin;
                }
            }
        }
    }

    .dot {
        display: inline;
        width: 0.75vw;
        height: 0.75vw;
        padding: 0.33vmin;
    }

    .new {
        display: inline;
        width: 1.6vw;
        padding-left: 0.67vmin;
    }
}

::v-deep {
}
</style>
